import {useNavigate, useParams, Link} from "react-router-dom";
import {useForm} from "react-hook-form";
import React, {useState, useEffect, useContext, forwardRef} from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  HStack,
  VStack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input, Divider,
  Textarea, Alert, AlertIcon, AlertTitle,
  Select,
  Checkbox,
  InputProps,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter,
} from '@chakra-ui/react';
import ReactPaginate from "react-paginate";

import {client} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";
import {Schoolroom} from "@/pbgen/v1/main_pb"
import {User} from "@/pbgen/v1/main_pb"
import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"

import './ListForm.css';

export const Schoolrooms = () => {
  const [schoolrooms, setSchoolrooms] = useState<Schoolroom[]>([]);
  const [vendors, setVendors] = useState<User[]>([]);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(schoolrooms.length / itemsPerPage);
  const [itemsOffset, setItemsOffset] = useState(0);
  const endOffset = itemsOffset + itemsPerPage
  const currentUsers = schoolrooms.slice(itemsOffset, endOffset);
  const {globalState, setGlobalState} = useContext(GlobalContext);
  const navigate = useNavigate();
  const { vid } = useParams();
  const [currentRole, setCurrentRole] = useState<string | undefined>(undefined)

  useEffect(() => {
    (async () => {
      if (! vid) {
        const resp = await client.getVendors({
          bearerToken: bearerToken(),
        });
        if (!resp.currentUser) {
          navigate("/login", {relative: "path"});
          return;
        }
        if (resp.vendors.length === 0) {
          navigate("/manage", {relative: "path"});
          return
        }
        const newVid = resp.vendors[0].id;
        navigate(`../vendors/${newVid}/schoolrooms`, {relative: "path", replace: true});
        return
      }
      const resp = await client.getSchoolrooms({
        bearerToken: bearerToken(),
        optVendorId: vid,
      });
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
      if (! resp.currentUser) {
        navigate("/login", { relative: "path" });
        return;
      }
      setCurrentRole(resp.currentUser.optRole);
      setSchoolrooms(resp.schoolrooms);
      if (resp.currentUser.optRole === "admin") {
        const resp = await client.getVendors({
          bearerToken: bearerToken(),
        });
        setVendors(resp.vendors);
      } else {
        const resp = await client.getUser({
          bearerToken: bearerToken(),
          id: vid,
        })
        if (! resp.user) {
          navigate("/manage", {relative: "path"});
          return
        }
        setVendors([resp.user])
      }
    })();
  }, [vid]) // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageClick = (e: { selected: number }) => {
    const newOffset = (e.selected * itemsPerPage);
    setItemsOffset(newOffset);
  }

  return <Page>
    <PageHeader title={"教室一覧"}>
      <HStack padding={2}>

        {(currentRole === "admin") ? 
          <Select placeholder="事業者を選択" value={vid} onChange={(e) => navigate(`../../${e.target.value}/schoolrooms`, {relative: "path", replace: true})}>
          {
            vendors.map((vendor) =>
              <option key={vendor.id} value={vendor.id}>{vendor.optName ?? ""}</option>
            )
          }
        </Select>
      : null }

        <Button px={9} onClick={() => {navigate("./new", { relative: "path" })}}>教室新規登録</Button>

        {/* <Button onClick={() => {navigate("../..", { relative: "path" })}}>戻る</Button> */}
        {/* <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>*/}
        <Button px={9} as={Link} to="/manage">メニューに戻る</Button>
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>

      </HStack>
    </PageHeader>

    <PageBody>
      <VStack>
        <Table className="list_table">
          <Thead>
            <Tr>
              <Th width={'10em'}>教室番号</Th>
              <Th>教室名</Th>
              <Th width={'10em'}>生徒リスト</Th>
              <Th width={'10em'}>編集</Th>
            </Tr>
          </Thead>
          <Tbody>
          {
            currentUsers.map((schoolroom) => <Tr key={schoolroom.id}>
              <Td>{schoolroom.optRoomNumber ?? ""}</Td>
              <Td style={{ textAlign: "left" }}><span className="list_table_name" >{schoolroom.optName ?? ""}</span></Td>
              <Td><Button onClick={() => {navigate(`./${schoolroom.id}/students`, { relative: "path" })}}>生徒</Button></Td>
              <Td><Button onClick={() => {navigate(`./${schoolroom.id}`, { relative: "path" })}}>編集</Button></Td>
            </Tr>)
          }
          {
            [...Array(itemsPerPage - currentUsers.length)].map((_, i) => (
              <Tr key={`dummy-${i}`}>
              <Td>—</Td>
              <Td>—</Td>
              <Td>—</Td>
              <Td>—</Td>
            </Tr>))
          }
          </Tbody>
        </Table>
        {/*<ReactPaginate pageCount={pageCount} onClick={handlePageClick} />*/}
        <ReactPaginate 
          previousLabel="前へ"
          nextLabel="次へ"
          breakLabel="..."
          pageCount={pageCount} onPageChange={handlePageClick} className={'react-paginate'} />
      </VStack>
    </PageBody>
  </Page>
}


type FormData = {
  id: string;
  roomNumber: string;
  name: string;
  representativeName: string;
  postalNumber: string;
  address1: string;
  address2: string;
  phoneNumber: string;
  email: string;
  note: string;
};

export const SchoolroomPage = () => {
  const [formError, setFormError] = useState('');
  const {
    register: registerElement,
    handleSubmit: wrapSubmitHandlerWithFormValidator,
    formState: { errors: formErrors },
    setValue,
  } = useForm<FormData>();
  const {globalState, setGlobalState} = useContext(GlobalContext);
  const navigate = useNavigate();
  const {vid, rid: ridStr} = useParams();
  const { isOpen: isErrorOpen, onOpen: onErrorOpen, onClose: onErrorClose } = useDisclosure()
//  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure()
  const { isOpen: isFinishOpen, onOpen: onFinishOpen, onClose: onFinishClose } = useDisclosure()

  useEffect(() => {
    (async () => {
 
      console.log(vid);
      console.log(ridStr);


      if (!vid || !ridStr) {
        navigate("/manage", {relative: "path"});
        return;
      }
      if ("new" === ridStr) {

        const resp = await client.getSchoolroomLastNumber({
          bearerToken: bearerToken(),
          vendorId: vid,
        });
//        setValue("id", (parseInt(resp.lastId) + 1).toString().padStart(resp.lastId.length, "0"))
        setValue("roomNumber", (parseInt(resp.lastRoomnumber) + 1).toString().padStart(resp.lastRoomnumber.length, "0"))
        return;      
      }

      const rid = parseInt(ridStr);
      const resp = await client.getSchoolroom({
        bearerToken: bearerToken(),
        id: rid,
      });
      if (!resp.currentUser) {
        navigate("/login", {relative: "path"});
        return;
      }
      if (! resp.schoolroom) {
        navigate("..", {relative: "path"});
        return;
      }
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})

      setValue("id", resp.schoolroom.id.toString());
      setValue("roomNumber", resp.schoolroom.optRoomNumber ?? "");
      setValue("name", resp.schoolroom.optName ?? "");
      setValue("representativeName", resp.schoolroom.optRepresentativeName ?? "");
      setValue("postalNumber", resp.schoolroom.optPostalNumber ?? "");
      setValue("address1", resp.schoolroom.optAddress1 ?? "");
      setValue("address2", resp.schoolroom.optAddress2 ?? "");
      setValue("phoneNumber", resp.schoolroom.optPhoneNumber ?? "");
      setValue("email", resp.schoolroom.optEmail ?? "");
      setValue("note", resp.schoolroom.optNote ?? "");
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleOk = () => {
    navigate(-1);
  };

  const submitIfValid = wrapSubmitHandlerWithFormValidator(async (data) => {
    console.log(data)

    const schoolroom = new Schoolroom({

//      id: ("new" === ridStr)? undefined: data.id,

      id: parseInt(data.id),
      optVendorId: vid,
      optRoomNumber: data.roomNumber,
      optName: data.name,
      optRepresentativeName: data.representativeName,
      optPostalNumber: data.postalNumber,
      optAddress1: data.address1,
      optAddress2: data.address2,
      optPhoneNumber: data.phoneNumber,
      optEmail: data.email,
      optNote: data.note,
    });

    console.log(schoolroom)

    const resp = await client.saveSchoolroom({
      bearerToken: bearerToken(),
      schoolroom: schoolroom,
      newSchoolroom: ("new" === ridStr),
    });

    if (resp.error) {
      setFormError(resp.error.message);
      onErrorOpen();
      return;
    } else {
      onFinishOpen();      
    }



    if (ridStr === "new") {
      navigate(`../${resp.id}`, {relative: "path"});
    }
  });

  return <Page>
    <PageHeader title={("new" === ridStr)? "教室新規登録": "教室編集"}>
      <HStack padding={2}>
        <Button onClick={submitIfValid}>{("new" === ridStr)? "登録": "保存"}</Button>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>
        {/* <Button isDisabled={true} onClick={() => {navigate("..", { relative: "path" })}}>削除</Button> */}
      </HStack>
    </PageHeader>


    <PageBody>
      <VStack className="edit_form" spacing={4} align="start">

        <FormControl isInvalid={Boolean(formErrors.roomNumber)}>
          <FormLabel><span>教室番号</span></FormLabel>

          <Input className="edit_form_short" disabled autoComplete={"off"} {...registerElement("roomNumber", {})} />
          {/* <Input isDisabled={("new" !== ridStr)} autoComplete={"off"} {...registerElement("roomNumber", {})} /> */}
          <FormErrorMessage>{ formErrors.roomNumber?.message }</FormErrorMessage>
        </FormControl>

        <HStack>

          <FormControl isInvalid={ Boolean(formErrors.name) } isRequired>
            <FormLabel 
              requiredIndicator = {
                <span style={{ color: "white", fontSize: "70%", backgroundColor:"#df6694", marginLeft: "4px",}}>✱必須項目</span>
              }>
              <span>教室名</span>
            </FormLabel>
            <Input className="edit_form_long" {...registerElement("name", {
              required: "教室名は必須項目です。"
            })} />
            <FormErrorMessage>{ formErrors.name?.message }</FormErrorMessage>
          </FormControl>

          <FormControl >
            <div className="edit_form_summary">
              教室名は必須項目です。
           </div>
          </FormControl>

        </HStack>

        <FormControl isInvalid={ Boolean(formErrors.representativeName) }>
          <FormLabel><span>代表者名</span></FormLabel>
          <Input className="edit_form_long"　{...registerElement("representativeName", {})} />
          <FormErrorMessage>{ formErrors.representativeName?.message }</FormErrorMessage>
        </FormControl>

        <Divider />

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.postalNumber) }>
            <FormLabel><span>郵便番号</span></FormLabel>
            <Input className="edit_form_short" 
              type="number"
              {...registerElement("postalNumber", 
                {
                  pattern: {
                    value: /^\d{7}$/,
                    message: "郵便番号はハイフン'-'無し半角数字7桁で入力してください。",
                  },
                }
              )} />
            <FormErrorMessage>{ formErrors.postalNumber?.message }</FormErrorMessage>
          </FormControl>    
          <FormControl >
            <div className="edit_form_summary">
              郵便番号はハイフン'-'無し半角数字7桁で入力してください。<br />
              例）1020074
          </div>
          </FormControl>
        </HStack>

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.address1) }>
            <FormLabel><span>住所１</span></FormLabel>
            <Input className="edit_form_long" {...registerElement("address1", {})} />
            <FormErrorMessage>{ formErrors.address1?.message }</FormErrorMessage>
          </FormControl>
          <FormControl >
            <div className="edit_form_summary">
              都道府県・市区町村・町域・番地で入力してください。<br />
              例）東京都千代田区九段南1-5-6
            </div>
          </FormControl>
        </HStack>

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.address2) }>
            <FormLabel><span>住所２</span></FormLabel>
            <Input className="edit_form_long" {...registerElement("address2", {})} />
            <FormErrorMessage>{ formErrors.address2?.message }</FormErrorMessage>
          </FormControl>
          <FormControl >
            <div className="edit_form_summary">
              建物名・マンション名・部屋番号等を入力してください。<br />
              例）りそな九段ビル5F
            </div>
          </FormControl>
        </HStack>

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.phoneNumber) }>
            <FormLabel><span>電話番号</span></FormLabel>
            <Input className="edit_form_middle"
            type="string"
            {...registerElement("phoneNumber", 
              {
                pattern: {
                  value: /^\(?\d{1,4}\)?-?\(?\d{1,4}-?\)?\d{4}$/,
                  message: "電話番号を半角文字で入力してください。",
                },
              }
            )} />
            <FormErrorMessage>{ formErrors.phoneNumber?.message }</FormErrorMessage>
          </FormControl>
          <FormControl >
            <div className="edit_form_summary">
              電話番号を半角文字で入力してください。<br />
              例）03-6869-2414
            </div>
          </FormControl>
        </HStack>

        <HStack>
          <FormControl isInvalid={ Boolean(formErrors.email) }>
            <FormLabel><span>メールアドレス</span></FormLabel>
            <Input className="edit_form_long" 
              {...registerElement("email", {
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "メールアドレスを半角文字で入力してください。",
                },
              }
            )} 
            />
            <FormErrorMessage>{ formErrors.email?.message }</FormErrorMessage>
          </FormControl>
          <FormControl >
            <div className="edit_form_summary">
              メールアドレスを半角文字で入力してください。<br />
              例）info@yuber.jp
            </div>
          </FormControl>
        </HStack>

        <FormControl isInvalid={Boolean(formErrors.note)}>
          <FormLabel><span>備考</span></FormLabel>
          <Textarea size="lg" {...registerElement("note") } />
          <FormErrorMessage>{ formErrors.note?.message }</FormErrorMessage>
        </FormControl>


        <Modal isOpen={isFinishOpen} onClose={onFinishClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>保存</ModalHeader>
            <ModalCloseButton />
            <ModalBody>教室情報を保存しました。</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleOk}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal isOpen={isErrorOpen} onClose={onErrorClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Error</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{formError}</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={onErrorClose}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

      </VStack>
    </PageBody>
  </Page>;
};

